import { render, staticRenderFns } from "./PhysicianSearch.vue?vue&type=template&id=2bfbb166&scoped=true&"
import script from "./PhysicianSearch.vue?vue&type=script&lang=js&"
export * from "./PhysicianSearch.vue?vue&type=script&lang=js&"
import style0 from "./PhysicianSearch.vue?vue&type=style&index=0&id=2bfbb166&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfbb166",
  null
  
)

component.options.__file = "PhysicianSearch.vue"
export default component.exports